// api.js

import axios from "axios";

const api = axios.create({
  baseURL: "/api", // Adjust the base URL as needed
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token in the headers if it exists
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Ensure the key matches how you store the token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const powersearch = (
  query,
  algorithmId,
  serial_number,
  language,
  log_query
) => {
  return api.post("/powersearch/powersearch", {
    query,
    algorithmId,
    serial_number,
    language,
    log_query,
  });
};

// Logs Dashboard API endpoints
export const getLogs = (page = 1, perPage = 20, filters = {}) => {
  const params = {
    page,
    per_page: perPage,
    ...filters,
  };
  return api.get("/logs/logs", { params });
};

export const getLogsStats = (grouping = "day", daysBack = 30) => {
  return api.get("/logs/logs/stats", {
    params: {
      grouping,
      days_back: daysBack,
    },
  });
};

export const exportLogs = (filters = {}) => {
  return api.get("/logs/logs/export", {
    params: filters,
    responseType: "blob",
  });
};

// Add to your api.js
export const getWordCloudData = (filters = {}) => {
  const params = {
    limit: 50,
    ...filters,
  };
  return api.get("/logs/logs/wordcloud", { params });
};
// Export the api instance and individual functions
export default api;
